import React, { useEffect, useState } from 'react'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import { getAlldiagnostic, requestDiagnosticmapping } from '../../service/operations/api_methods'
import Cookies from "js-cookie";
import { toast } from 'sonner';


const FindDiagonictics = () => {
    const token = Cookies.get("token")
    const[list,setList]=useState(diagonistics)

    const handleGetAll=async()=>{
        try {
            const res=await getAlldiagnostic(token)
            console.log('getAlldiagnostic',res);
            if(res.status===200){
                setList(res.data.data)
            }
            
        } catch (error) {
           console.log(error);
            
        }
    }

        const handleReqauestMapping=async(id)=>{
            try {
                let data={
                    diagnostic_center_user_id:id
                }
                const res= await requestDiagnosticmapping(token,data)
                console.log(res);
                if(res.status===200){
                    toast.success(res.data.message)
                    handleGetAll()
                }
                
            } catch (error) {
                console.log(error);
                toast.error(error?.message||"Failed to send request")
                
            }
         }

    useEffect(() => {
     handleGetAll()
    }, [])
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
        <Header/>
        <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-between",padding:"6px"}}>
            <p style={{color:"white"}}>All registered Diagnostic Center </p>
            <input placeholder='Search Diagnostic by Adhaar'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            <p style={{fontSize:"14px",padding:"5px",borderRadius:"6px",backgroundColor:"#fefefe",cursor:"pointer"}}>Register New</p>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"20vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                   { item.requestStatus?<p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px" }}
                    onClick={()=>toast.info("Request is pending")}>
                        {item.requestStatus}</p>
                        :
                         <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px" }}
                    onClick={()=>handleReqauestMapping(item.user_id)}>
                        Add to Assign</p>}
                    <img src='/Assets/diagonasitic.jpg' style={{height:"30%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.center_name||"Medical name"}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>{item.license_number||""}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.address||""}</span></p>
                           
                        
                            
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
     
    </div>
  )
}

export default FindDiagonictics
